import React, { useCallback } from "react";
import { ChakraProps, useToast } from "@chakra-ui/react";
import AsyncSelect from "./AsyncSelect";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import { getSfx } from "../../api/sounds/sounds";

interface SelectSfxProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectSfx: React.FC<SelectSfxProps> = ({ color, value, setValue, ...chakraProps }) => {
  const toast = useToast();

  const handleSearch = useCallback(
    async (searchQuery?: string): Promise<[string, string][]> => {
      let sfx: string[] = [];

      try {
        sfx = await getSfx(searchQuery);
      } catch (error) {
        toast({
          title: "API error occurred",
          description: (error as Error).message,
          status: "error",
        });
      }

      return sfx.map((fileName) => [fileName, fileName]);
    },
    [toast, getSfx]
  );

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect selectedValue={value} setSelectedValue={setValue} color={color} title={"Sfx"} {...chakraProps} />
    </AsyncSearchProvider>
  );
};

export default SelectSfx;
